import numeral from "numeral";

export const formatNumberWithCommas = (value: number) => {
  return numeral(value).format("0,0");
};

export const formatNumberWithAbbreviation = (value: number) => {
  if (value < 1000) {
    return numeral(value).format("0");
  }
  return numeral(value).format("0.0a").toUpperCase();
};
